module.exports = __webpack_public_path__ + "img/pause.5180b814.svg";